module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vue-map"
  }, [_c('div', {
    ref: "map",
    staticClass: "map-container"
  }), _vm._v(" "), _vm._t("default")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a3a9653!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 99
// module chunks = 2